import React from 'react'
import { Link } from 'react-router-dom'
import Photo from '@resources/imgs/mask-group-2.png'
import IDonor from '@interfaces/IDonor'
import ICustomImportDonor from '@interfaces/ICustomImportDonor'

interface DonorInfoSectionProps {
  donor: IDonor | ICustomImportDonor
  isNational: boolean
  showPhotoMatch: boolean
  isPhotoMatchEligible: boolean
  disableLink?: boolean
}

const DonorInfoSection: React.FC<DonorInfoSectionProps> = ({ donor, isNational, showPhotoMatch, isPhotoMatchEligible, disableLink = false }) => {
  const donorLabel = `${donor.internal_id}${donor.nickname ? ` - ${donor.nickname}` : ''}`

  return (
    <div className="donor-card__info-section">
      <figure className="donor-avatar">
        <img src={donor.avatar || Photo} alt="" />
      </figure>
      <div className="donor-details">
        <div className="d-flex flex-column gap-5">
          {disableLink ? (
            <span className="donor-id">{donorLabel}</span>
          ) : (
            <Link to={`/doadores/${String(donor.internal_id).toLowerCase()}`} target="_blank" className="donor-id">
              {donorLabel}
            </Link>
          )}
          <span className={`donor-origin-badge donor-origin-badge--${isNational ? 'national' : 'imported'}`}>
            {isNational ? 'Nacional' : 'Importado'}
          </span>
        </div>
      </div>
    </div>
  )
}

export default DonorInfoSection
